import React from 'react';
import { View, ScrollView, Alert, Text } from 'react-native';
import { connect } from 'react-redux';
import { addContentToUserProgress } from "../../../../redux/actions";

import Colors from "../../../../constants/Colors";
import QuizQuestion from "./QuizQuestion";
import PaginationController from "./PaginationController";
import {ButtonWithSpinner, InformationDialogue, Spacing, SpinnerControl, SpinnerDialogue} from "../../../../components";
import get from "../../../../api/methods/get";
import {CONTENT_GET_SPECIFIC, QUIZ_GET_USER_ANSWER} from "../../api/journeyEndpoints";
import QuizResult from "./quizResult/QuizResult";
import NavBar from "../../../../components/NavBar";
import queryString from "query-string";


class Quiz extends React.Component {

    state = {
        isFetching: false,
        contentData: null,

        isGettingAnswer: false,
        userAnswerData: null,

        questions: [],
        currentQuestion: 0,

        isSending: false,
        showFeedback: false,

        showSuccessModal: false,
    }

    handleSend = async () => {
        if (this.state.isSending) return;
        this.setState({ isSending: true });

        try {

            let questionsAnswer = this.state.questions.map(item => {
                return {
                    questionIndex: item.questionIndex,
                    userSelectedIndex: item.userSelectedIndex,
                }
            })

            await this.props.addContentToUserProgress("quiz", this.state.contentData.id, { userAnswers: questionsAnswer });
            await this.fetchContentUser();
            this.setState({ showSuccessModal: true });

        } catch (e) {

        }

        this.setState({ isSending: false });
    }

    haveAnsweredAllQuestions = () => {

        if (this.state.questions.length === 0)
            return false;

        for (let question of this.state.questions) {
            if (question.userSelectedIndex === -1)
                return false;
        }

        return true;
    }

    fetchOriginal = async () => {
        if (this.state.isFetching) return;
        this.setState({ isFetching: true });
        try {
            const values = queryString.parse(this.props.location.search);
            const contentId = values.contentId;
            let result = await get(CONTENT_GET_SPECIFIC("quiz", contentId));
            let json = await result.json()
            json.data.questions = json.data.questions.map((item, index) => {
                return {
                    ...item,
                    questionIndex: index,
                    userSelectedIndex: -1,
                }
            })

            this.setState({ contentData: json.data, questions: json.data.questions });
            this.setState({ isFetching: false });
            return json;
        } catch (e) {
            console.log(e);
        }

        this.setState({ isFetching: false });
    }

    fetchUserAnswer = async (journeyId, contentId, userId) => {
        if(this.state.isGettingAnswer) return;
        this.setState({ isGettingAnswer: true })

        try {
            const endpoint = QUIZ_GET_USER_ANSWER(journeyId, contentId, userId);

            const result = await get(endpoint);
            const json = await result.json();

            this.setState({ userAnswerData: json.data === undefined ? null : json.data })

            if (json.data !== undefined)
                this.setState({ showFeedback: true });

        } catch (e) {
            console.log(e);
        }

        this.setState({ isGettingAnswer: false })
    }

    fetchContentUser = async () => {

        const contentData = await this.fetchOriginal();

        const userId = this.props.userId;
        const values = queryString.parse(this.props.location.search);
        const contentId = values.contentId;
        const journeyId = this.props.currentJourneyId;

        const userAnswerData = await this.fetchUserAnswer(journeyId, contentId, userId);
    }

    componentDidMount() {
        this.fetchContentUser();
    }

    renderFeedbackArea = () => {
        const isCompleted = this.props.location.state.isCompleted;
        if (isCompleted === true || this.state.showFeedback === true) {
            const isFetchingContentAnswer = this.state.isFetching === true || this.state.isGettingAnswer === true;
            return (
                <View>
                    <SpinnerControl isFetching={isFetchingContentAnswer} text={"Estamos carregando o conteúdo e sua resposta!"} />

                    <View style={{ alignItems: 'center', width: 400 }} >
                        {
                            (this.state.questions.length > 0 && this.state.userAnswerData !== null) &&
                            <QuizResult
                                userAnswerData={this.state.userAnswerData.userAnswers[this.state.currentQuestion]}
                                questionData={this.state.questions[this.state.currentQuestion]}
                                questionIndex={this.state.currentQuestion}
                                userSelectionValue={this.state.userAnswerData.userAnswers[this.state.currentQuestion].userSelectedIndex}
                            />
                        }
                    </View>

                    {
                        this.state.questions.length > 1 &&
                        <PaginationController
                            onMoveLeft={() => {
                                let moveLeft = this.state.currentQuestion - 1;
                                if (moveLeft < 0) moveLeft = 0;
                                this.setState({ currentQuestion: moveLeft });
                            }}
                            onMoveRight={() => {
                                let moveLeft = this.state.currentQuestion + 1;
                                if (moveLeft > this.state.questions.length - 1) moveLeft = this.state.questions.length - 1;
                                this.setState({ currentQuestion: moveLeft });
                            }}
                            selectedIndex={this.state.currentQuestion}
                            elements={this.state.questions}
                        />
                    }
                </View>
            )
        }
    }

    renderQuestionsArea = () => {
        const isCompleted = this.props.location.state.isCompleted;
        if (isCompleted === true || this.state.showFeedback === true)
            return null;

        const canSend =  this.haveAnsweredAllQuestions();

        return (
            <View>
                <SpinnerControl isFetching={this.state.isFetching} text={"Estamos carregando o conteúdo!"} />

                {
                    this.state.contentData !== null &&
                    <View style={{  alignItems: 'center', flex: 1, width: '100%' }}>
                        <View style={{ height: '80%' }}>
                            <View style={{ alignItems: 'center' }} >
                                {
                                    this.state.questions.length > 0 &&
                                    <QuizQuestion
                                        questionData={this.state.questions[this.state.currentQuestion]}
                                        onSelection={(newSelection, index) => {
                                            let questions = Array.from(this.state.questions)
                                            questions[this.state.currentQuestion].userSelectedIndex = newSelection;
                                            this.setState({ questions: questions });
                                        }}
                                        questionIndex={this.state.currentQuestion}
                                        userSelectionValue={this.state.questions[this.state.currentQuestion].userSelectedIndex}
                                    />
                                }
                            </View>
                        </View>

                        <Spacing height={30} />

                        {
                            this.state.questions.length > 1 &&
                            <PaginationController
                                onMoveLeft={() => {
                                    let moveLeft = this.state.currentQuestion - 1;
                                    if (moveLeft < 0) moveLeft = 0;
                                    this.setState({ currentQuestion: moveLeft });
                                }}
                                onMoveRight={() => {
                                    let moveLeft = this.state.currentQuestion + 1;
                                    if (moveLeft > this.state.questions.length - 1) moveLeft = this.state.questions.length - 1;
                                    this.setState({ currentQuestion: moveLeft });
                                }}
                                selectedIndex={this.state.currentQuestion}
                                elements={this.state.questions}
                            />
                        }

                        <ButtonWithSpinner
                            isLoading={this.state.isSending}
                            text={'Enviar'}
                            onPress={this.handleSend}
                            containerPropsStyle={{ height: '8%', borderRadius: 8, width: '90%', alignSelf: 'center', marginTop: 20 }}
                            textPropsStyle={{ fontSize: 18 }}
                            disabled={!canSend}
                        />
                    </View>
                }
            </View>
        )
    }

    render() {

        return (
            <NavBar title={"Quiz"}>

                <SpinnerDialogue
                    isModalVisible={this.state.isSending}
                    onClose={() => {}}
                    isFinished={!this.state.isSending}
                    titleProps={"Enviando!"}
                    messageProps={"Estamos enviando suas respostas!"}
                />

                <InformationDialogue
                    isModalVisible={this.state.showSuccessModal}
                    titleText={"Sucesso!"}
                    descriptionText={"A sua resposta para este quiz foi enviada com sucesso!"}
                    buttons={[
                        {
                            text: 'Feedback',
                            onPress: () => this.setState({ showSuccessModal: false, showFeedback: true })
                        },
                        {
                            text: 'Voltar',
                            onPress: () => this.props.history.goBack()
                        }
                    ]}
                />

                { this.renderFeedbackArea() }
                { this.renderQuestionsArea() }

            </NavBar>
        )
    }
}

const mapStateToProps = state => {
    return {
        userId: state.user.userId,
        currentJourneyId: state.journey.currentJourney.id,
    }
}

export default connect(mapStateToProps, { addContentToUserProgress })(Quiz);
